import { AfterViewInit, Directive, inject, OnDestroy } from '@angular/core';
import { NgbDropdown } from '@ng-bootstrap/ng-bootstrap';
import { DropdownScrollMonitorService } from '../services/dropdown-scroll-monitor.service';

@Directive({
  selector: '[autoCloseDropdown]',
  standalone: false,
})
export class AutoCloseDropdownOnScrollDirective implements AfterViewInit, OnDestroy {
  private readonly dropdown = inject(NgbDropdown, { host: true });
  private readonly dropdownMonitorService = inject(DropdownScrollMonitorService);

  ngAfterViewInit() {
    this.dropdownMonitorService.register(this.dropdown);
  }

  ngOnDestroy() {
    this.dropdownMonitorService.unregister(this.dropdown);
  }
}
